<template>
	<div class="com-list-content">
		<com-search :model="search" :transfer-model.sync="condition" v-slot="{data}" :table="$refs.table">
			<ui-text v-model="data.phone" label="手机号"/>
			<ui-template>
				<ui-button type="search"></ui-button>
			</ui-template>
		</com-search>
		<com-table ref="table" url="/admin/user/list" :search="condition" v-slot="{data}">
			<ui-text v-model="data.id" label="ID" width="100"/>
			<ui-image v-model="data.avatar"></ui-image>
			<ui-text v-model="data.userName" label="用户名称"/>
			<ui-text v-model="data.miniWxOpenid" label="微信ID" width="350"/>
			<ui-select v-model="data.source" label="用户来源">
				<ui-option value="1" text="错题本"/>
				<ui-option value="2" text="语文助手"/>
			</ui-select>
			<ui-date v-model="data.createTime" type="datetime" label="注册时间"/>
		</com-table>
	</div>
</template>

<script>
export default {
	data(){
		return {
			search:{},
			condition:{},
		};
	},
	mounted(){
	},
	methods:{
		add(){
			this.$dialog('demo_detail',{type:'add',data:{}},()=>{
				this.$refs.table.refresh();
			})
		},
		edit(data){
			this.$dialog('demo_detail',{type:'edit',data:data},()=>{
				this.$refs.table.refresh();
			})
		},
		remove(data){
			this.$axios.delete('/dbDataType/'+data.id)
			.then(data=>{
				this.$refs.table.refresh();
			}).end();
		}
	}
}
</script>

<style>
</style>
